import { Box, Button } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { confirm } from "lib/@dialogs/confirm"
import { alert } from "lib/@dialogs/alert"
import { runBulk } from "routes/schedule/my-schedules/my-custom-schedules/bulk-runner"
import { deleteRetiredSchedules } from "routes/schedule/my-schedules/my-custom-schedules/controller/delete-retired-schedules"
import { CustomScheduleActions } from "./selection-actions-slot-definitions"
import { clearRetired, succeeded } from "./selection-actions-helpers"

CustomScheduleActions.plug(<DeleteRetiredButton if={({ retiredItems = [] }) => retiredItems.length} priority={40} />)

export function DeleteRetiredButton() {
    const { retiredItems = [], regimeUsage = [] } = useBoundContext()

    return (
        <Button
            size="small"
            color="error"
            startIcon={<Iconify icon="gravity-ui:trash-bin" />}
            onClick={deleteRetired}
            data-cy="bulk-delete-retired"
        >
            Delete {retiredItems.length}
        </Button>
    )

    async function deleteRetired() {
        const usageMap = new Map(regimeUsage.map((u) => [u.id, u.regimes]))
        const blocked = retiredItems.filter((m) => usageMap.get(m._id)?.length)
        const deletable = retiredItems.filter((m) => !usageMap.get(m._id)?.length)

        if (deletable.length === 0) {
            await alert(<Box sx={{ whiteSpace: "pre-line" }}>{blockedText(blocked)}</Box>, "Nothing to delete")
            return
        }

        const ok = await confirm(
            <Box sx={{ whiteSpace: "pre-line" }}>{deleteText(deletable, blocked)}</Box>,
            `Delete ${deletable.length} retired ${"schedule".pluralize(deletable.length)}`,
            undefined,
            "Delete",
            { okColor: "error", okIcon: "gravity-ui:trash-bin", cancelIcon: "mdi:close-circle-outline" }
        )
        if (!ok) return
        const ids = deletable.map((m) => m._id)
        const { failed } = await runBulk(ids, { progress: "Deleting", past: "Deleted" }, deleteRetiredBatch)
        clearRetired(succeeded(ids, failed))
    }

    function deleteRetiredBatch(batch) {
        return deleteRetiredSchedules(batch)
            .then((result) => {
                const deleted = new Set(result?.deleted ?? [])
                return batch.filter((id) => !deleted.has(id))
            })
            .catch(() => batch)
    }

    function deleteText(deletable, blocked) {
        const base = `${deletable.length} ${"schedule".pluralize(deletable.length)} will move to the Recycle Bin, where you can restore ${
            deletable.length === 1 ? "it" : "them"
        }.`
        return blocked.length ? `${base}\n\n${blockedText(blocked)}` : base
    }

    function blockedText(blocked) {
        return `${blocked.length} ${"schedule".pluralize(blocked.length)} cannot be deleted because ${
            blocked.length === 1 ? "it's" : "they are"
        } used by ${"regime".pluralize(blocked.length)}.`
    }
}
